/** @jsxImportSource @emotion/react */

import React, { forwardRef, useMemo } from 'react';
import { ClipLoader } from 'react-spinners';
import UDText from '../text';

import { MainBlock } from './styles';
import { theme } from 'styles/theme/theme';

interface IProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: JSX.Element;
  color?: string;
  hoverColor?: string;
  disabledColor?: string;
  width?: number;
  height?: number;
  disabled?: boolean;
  centered?: boolean;
  loading?: boolean;
  loaderSize?: number;
}

const UDEmptyButton = forwardRef<HTMLButtonElement, IProps>((props, ref) => {
  const { icon, color = theme.colors.SurfaceRaisinBlack50, children, centered, loaderSize = 18, ...rest } = props;

  const body = useMemo(() => {
    if (props.loading) {
      // return <div className="loading" />;
      return <ClipLoader size={loaderSize} />;
    }

    return (
      <>
        {icon}
        {children && (
          <UDText style={{ color: 'inherit', fontSize: 'inherit' }} type={'subhead'}>
            {children}
          </UDText>
        )}
      </>
    );
  }, [children, icon, loaderSize, props.loading]);

  return (
    <MainBlock ref={ref} color={color} centered={centered ?? true} {...rest}>
      {body}
    </MainBlock>
  );
});

export default UDEmptyButton;
